module.exports = __webpack_public_path__ + "static/media/Aileron-Regular-01.18c5e399.svg";